import { Link } from "react-router-dom";
import { dynamicImage } from "../../../service";
import { Btn, H6, Image } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
 
 const organizationAccountBodyData = [
  {
    no: 1,
    image: "user1.jpg",
    accountName: "Tech Corp Inc.",
    accountId: "001",
    role: "Organization Admin",
    status: "Active",
    color: "success",
    users: 150,
    lastUpdated: "2025-07-22",
  },
  {
    no: 2,
    image: "user2.jpg",
    accountName: "Health Sync Ltd.",
    accountId: "002",
    role: "Manager",
    status: "Pending",
    color: "warning",
    users: 85,
    lastUpdated: "2025-07-20",
  },
  {
    no: 3,
    image: "user3.jpg",
    accountName: "Edu Future Org.",
    accountId: "003",
    role: "User",
    status: "Inactive",
    color: "danger",
    users: 30,
    lastUpdated: "2025-07-18",
  },
  {
    no: 4,
    image: "user3.jpg",
    accountName: "Green Energy Co.",
    accountId: "004",
    role: "Super Admin",
    status: "Active",
    color: "success",
    users: 200,
    lastUpdated: "2025-07-23",  
  },
  {
    no: 5,
    image: "user1.jpg",
    accountName: "Finance Pro Solutions",
    accountId: "005",
    role: "Manager",
    status: "Active",
    color: "success",
    users: 120,
    lastUpdated: "2025-07-21",
  },
  {
    no: 6,
    image: "user2.jpg",
    accountName: "Retail Max Corp.",
    accountId: "006",
    role: "User",
    status: "Pending",
    color: "warning",
    users: 75,
    lastUpdated: "2025-07-19",
  },
  {
    no: 7,
    image: "user3.jpg",
    accountName: "Tech Startup Inc.",
    accountId: "007",
    role: "Organization Admin",
    status: "Active",
    color: "success",
    users: 45,
    lastUpdated: "2025-07-17",
  },
  {
    no: 8,
    image: "user1.jpg",
    accountName: "Global Trade Ltd.",
    accountId: "008",
    role: "Super Admin",
    status: "Inactive",
    color: "danger",
    users: 180,
    lastUpdated: "2025-07-16",
  },
  {
    no: 9,
    image: "user1.jpg",
    accountName: "Innovation Hub Co.",
    accountId: "009",
    role: "Manager",
    status: "Active",
    color: "success",
    users: 95,
    lastUpdated: "2025-07-15",
  },
];

interface OrganizationAccountBodyProps {
  showCount?: number;
}

const OrganizationAccountBody = ({ showCount = 4 }: OrganizationAccountBodyProps) => {
  return (
    <>
      {organizationAccountBodyData.slice(0, showCount).map((data, i) => (
        <tr key={i}>
          
           <td>
            <div className="d-flex">
              <div className="flex-shrink-0">
                <Image src={dynamicImage(`dashboard/user/${data.image}`)} alt="account" className="img-fluid rounded-circle" style={{ width: '40px', height: '40px', objectFit: 'cover' }}  />
              </div>
              <div className="flex-grow-1 ms-3">
                <Link to={Href}>
                  <H6>{data.accountName}</H6>
                </Link>
              </div>
            </div>
          </td>
          <td>#{data.accountId}</td>
          <td>{data.role}</td>
          <td>
            <Btn color={data.color}>{data.status}</Btn>
          </td>
          <td>{data.users}</td>
         </tr>
      ))}
    </>
  );
};

export default OrganizationAccountBody;